<template>
  <body class="program-benefits-body">
    <div class="title">Program Benefits</div>
    <div class="text-wrapper">
      <div v-for="(benefit, index) in benefits" :key="index" class="text-box">
        <div class="line"></div>
        <div class="text">
          <span>{{ benefit.highlight }}</span> {{ benefit.text }}
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "ProgramBenefits",
  data() {
    return {
      benefits: [
        { highlight: "Exclusive Discounts", text: "on Wecobi services" },
        {
          highlight: "Enhanced Visibility",
          text: "through targeted marketing campaigns",
        },
        { highlight: "Collaborative Growth", text: "on Wecobi services" },
        {
          highlight: "Brand Alignment",
          text: "with global sustainability trends, including compliance with emerging EU regulations on waste and circular economy models",
        },
      ],
    };
  },
};
</script>

<style scoped>
.program-benefits-body {
  width: 100%;
  height: 500px;
  border-radius: 20px;
  padding: 70px 100px 55px 100px;
  box-sizing: border-box;
  background-image: url("../../../assets/PartnersProgram/ProgramBenefits.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.title {
  font-size: 45px;
  font-weight: 600;
  line-height: 1.2;
  color: #ffffff;
  width: 100%;
}
.text-wrapper {
  width: 1032px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
}
.text-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 400px;
}
.line {
  width: 50px;
  height: 2px;
  background-color: #f98140;
  border-radius: 20px;
}
.text {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
span {
  color: #f98140;
  font-weight: 700;
}

@media (max-width: 1280px) {
  .program-benefits-body {
    padding: 70px 90px 55px 90px;
  }
}
@media (max-width: 1024px) {
  .program-benefits-body {
    padding: 70px 80px 55px 80px;
  }

  .text-wrapper {
    width: 704px;
  }
  .text-box {
    width: 332px;
  }
  .title {
    font-size: 40px;
  }
  .text {
    font-size: 14px;
  }
}
@media (max-width: 744px) {
  .program-benefits-body {
    height: fit-content;
    padding: 70px 60px 90px 60px;
    gap: 70px;
  }
  .text-wrapper {
    width: 591px;
  }
  .text-box {
    max-width: 275px;
  }
}
@media (max-width: 588px) {
  .program-benefits-body {
    height: fit-content;
    padding: 70px 50px 90px 50px;
  }
  .text-wrapper {
    width: 455px;
  }
  .text-box {
    width: 207px;
  }
}

@media (max-width: 431px) {
  .program-benefits-body {
    height: 621px;
    padding: 70px 40px 90px 40px;
  }
  .text-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 30px;
  }
  .text-box {
    width: 100%;
  }
  .title {
    font-size: 35px;
  }
}
</style>
